<template>
    <div class="col-lg-4 case-box" :class="shortname">
        <div class="headline" :class="position">
            <b>{{ name }}</b><br>
            {{ type }}
        </div>
        <div class="overlay">
            <div class="inside-overlay">
                Læs mere om vores løsning til <b>{{ name }}</b>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            name: {
            },
            type: {
            },
            shortname: {
            },
            position: {
            }
        }
    }
</script>
<style lang="scss" scoped>
    .case-box{
        height: 250px;
    }
    .quooker{
        background: url('https://quooker.deveo.dk/img/login-bg.jpg') center center;
        background-size: cover;
    }
    .julehjaelpen{
        background: url('https://static.pexels.com/photos/257909/pexels-photo-257909.jpeg') center center;
        background-size: cover;
    }
    .headline{
        position: absolute;
        color: #fff;
    }
    .top-left{ top: 15px; left: 15px; }
    .top-right{ top: 15px; right: 15px; text-align: right; }
    .bottom-left{ bottom: 15px; left: 15px; }
    .bottom-right{ bottom: 15px; right: 15px; text-align: right; }
    .overlay{
        opacity: 0;
        position: absolute;
        height: 100%;
        width: 100%;
        background: rgba(0,0,0,0.75);
        color: #fff;
        margin: 0 -15px;
        transition: 0.3s ease all;
    }
    .inside-overlay{
        position: absolute;
        width: 80%;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .case-box:hover .overlay{
        opacity: 1;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// case.vue?6bc61d66